import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdminUserResponse, AdminCreateUserRequest, AdminCreateSystemUserRequest, Permission, PageResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class UserAdminService {
  private http = inject(HttpClient);
  private base = `${environment.apis.identity}/admin/users`;

  getUsers(page = 0, size = 20, search?: string, role?: string): Observable<PageResponse<AdminUserResponse>> {
    let params = new HttpParams().set('page', page).set('size', size);
    if (search) params = params.set('search', search);
    if (role) params = params.set('role', role);
    return this.http.get<PageResponse<AdminUserResponse>>(this.base, { params });
  }

  getUserById(userId: string): Observable<AdminUserResponse> {
    return this.http.get<AdminUserResponse>(`${this.base}/${userId}`);
  }

  createUser(data: AdminCreateUserRequest): Observable<AdminUserResponse> {
    return this.http.post<AdminUserResponse>(this.base, data);
  }

  toggleLock(userId: string): Observable<AdminUserResponse> {
    return this.http.patch<AdminUserResponse>(`${this.base}/${userId}/toggle-lock`, {});
  }

  createSystemUser(data: AdminCreateSystemUserRequest): Observable<AdminUserResponse> {
    return this.http.post<AdminUserResponse>(`${this.base}/system`, data);
  }

  getPermissionCatalog(): Observable<Permission[]> {
    return this.http.get<Permission[]>(`${environment.apis.identity}/admin/permissions`);
  }

  getUserPermissions(userId: string): Observable<string[]> {
    // Le backend renvoie { permissions: string[] }, pas un tableau brut.
    return this.http.get<{ permissions: string[] }>(`${this.base}/${userId}/permissions`)
      .pipe(map(res => res.permissions));
  }

  updateUserPermissions(userId: string, codes: string[]): Observable<void> {
    // Le backend attend { permissions: string[] }, pas un tableau brut.
    return this.http.put<void>(`${this.base}/${userId}/permissions`, { permissions: codes });
  }
}
